import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListSearchQueryPaginationPayload } from '@app-store/slices/companies/listSearch'

interface TaskAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.listSearch

function* listSearchSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)

        const response = yield axios.get(`/companies`, {
            params
        })

        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSearchSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSearchSagaTask)
}

export default listSearchSaga
